// extracted by mini-css-extract-plugin
module.exports = {"login-toast":"login-toast-component_login-toast__3ApBZ","toast-content":"login-toast-component_toast-content__TzOh2","user":"login-toast-component_user__AqzTc"};